import { render, staticRenderFns } from "./CenterBlock.vue?vue&type=template&id=181f4777&scoped=true&"
import script from "./CenterBlock.vue?vue&type=script&lang=js&"
export * from "./CenterBlock.vue?vue&type=script&lang=js&"
import style0 from "./CenterBlock.vue?vue&type=style&index=0&id=181f4777&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f4777",
  null
  
)

export default component.exports